/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_RejectInputs */

const en_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject`)
};

const de_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

const fr_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeter`)
};

const es_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const it_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiuta`)
};

const nl_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afwijzen`)
};

const pl_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzuć`)
};

const fi_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylkää`)
};

const da_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvis`)
};

const sv_keyword_optimizer_reformulation_reject = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisa`)
};

/**
* | output |
* | --- |
* | "Reject" |
*
* @param {Keyword_Optimizer_Reformulation_RejectInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_reject = /** @type {((inputs?: Keyword_Optimizer_Reformulation_RejectInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_RejectInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_reject(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_reject(inputs)
	return en_keyword_optimizer_reformulation_reject(inputs)
});